import classNames from 'classnames'
import { forwardRef, HTMLAttributes } from 'react'

import { Slot } from '../utilities'
import styles from './chat-message.module.scss'

export type ChatMessageHeaderLabelElement = HTMLDivElement
export type ChatMessageHeaderLabelProps = HTMLAttributes<ChatMessageHeaderLabelElement> & {
  asChild?: boolean
}

export const ChatMessageHeaderLabel = forwardRef<
  ChatMessageHeaderLabelElement,
  ChatMessageHeaderLabelProps
>(function ChatMessageHeaderLabel(props, forwardedRef) {
  const { className, asChild, ...rest } = props
  const classes = classNames(styles.headerLabel, className)
  const Component = asChild ? Slot : 'div'
  return <Component {...rest} className={classes} ref={forwardedRef} />
})
